module.exports = __webpack_public_path__ + "85ff49296ea72e103d4859946d98c868.otf";